import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {SearchEventsService} from "../../components/search-container/search.service";
import {SideBarService} from "./sidebar.service";
import {MatSidenav} from "@angular/material/sidenav";

@Component({
    selector: 'app-site-layout',
    templateUrl: './site-layout.component.html',
    styleUrls: ['./site-layout.component.css']
})
export class SiteLayoutComponent implements OnInit,AfterViewInit {

    @ViewChild('drawer') public sidenav: MatSidenav;

    searchIsActive = false;
    showFiller = false;


    constructor(private searchEventsService: SearchEventsService,
                private sidebarService: SideBarService
    ) {


        this.searchEventsService.searchTriggeredEvent.subscribe(keyword => {

            if (keyword == "") {
                this.searchIsActive = false;
            } else {
                this.searchIsActive = true;
            }
        })

    }

    ngOnInit() {

    }

    ngAfterViewInit(): void {
        this.sidebarService.setSidenav(this.sidenav);
    }

}
